const mutations = {
  loadContent: (state, contentObj) => {
    state.content[contentObj.viewName] = contentObj.content;
  },
};

export default mutations;
